import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import type { AccordionStyle } from '@/types/types.ts';

/**
 * Form Skeleton
 */
export default function FormSkeleton() {

   return (
       <div className="policy-library-listing-hero-grid">
           <div className="policy-library-listing-left">
               <div className="policy-library-listing-intro">
                   <h1><Skeleton /></h1>
                   <p><Skeleton /></p>
               </div>
               <hr className="policy-library-listing-form-divider" />
               <div className="policy-library-listing-form">
                   <Skeleton className="Finder__input" height={55} />
                   <div className="select-filters">
                       <Skeleton className="category-filter" height={55} />
                       <Skeleton className="alpha-filter" height={55} />
                   </div>
               </div>
           </div>
               <div className="policy-library-callout">
                   <h2><Skeleton /></h2>
                   <button className="policy-library-callout-accordion-btn" disabled aria-expanded="false">
                       <Skeleton />
                       <span className="Accordion__icon"><svg width="22" height="22" fill="none"><g fill="#333"><path
                           d="M9 2h4v18H9z"></path><path d="M20 9v4H2V9z"></path></g></svg></span>
                   </button>
                   <div className="policy-library-callout-accordion" id="policy-library-callout-content"
                       style={{
                       '--height': `130px`
                   } as AccordionStyle }>
                       <p><Skeleton /></p>
                       <p><Skeleton /></p>
                           <ul>
                                   <li>
                                       <a href="#">
                                           <svg xmlns="http://www.w3.org/2000/svg" width="10" height="19">
                                               <path d="m8.889 8.527-5.171 8.528A15.567 15.567 0 0 1 0 15.333l4.128-6.806L0 1.722A15.735 15.735 0 0 1 3.718 0l5.17 8.527Z"></path>
                                           </svg>
                                           <span><Skeleton /></span>
                                       </a>
                                   </li>
                           </ul>
                   </div>
               </div>
       </div>
   );


}